import './Footer.css';

const quickLinks = [
  { label: 'Home', href: '#/home' },
  { label: 'About', href: '#/about' },
  { label: 'Services', href: '#/services' },
  { label: 'Portfolio', href: '#/portfolio' },
  { label: 'Blog', href: '#/blog' },
  { label: 'Contact', href: '#/contact' },
];

const serviceLinks = [
  'Website Development',
  'Digital Marketing',
  'Graphic Design',
  'AI Solutions',
  'Custom Software Development',
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">

        {/* Col 1 — Logo + about */}
        <div className="footer-col footer-brand">
          <div className="footer-logo-box">
            <img src="logo.png" alt="AerialRoot" />
          </div>
          <p className="footer-desc">
            A results-driven IT and digital marketing company helping
            businesses grow faster and smarter with cutting-edge technology.
          </p>
        </div>

        {/* Col 2 — Quick Links */}
        <div className="footer-col">
          <h4 className="footer-head">Quick Links</h4>
          <ul className="footer-list">
            {quickLinks.map((l) => (
              <li key={l.label}><a href={l.href}>{l.label}</a></li>
            ))}
          </ul>
        </div>

        {/* Col 3 — Services */}
        <div className="footer-col">
          <h4 className="footer-head">Services</h4>
          <ul className="footer-list">
            {serviceLinks.map((s) => (
              <li key={s}><a href="#/services">{s}</a></li>
            ))}
          </ul>
        </div>

        {/* Col 4 — Contact */}
        <div className="footer-col">
          <h4 className="footer-head">Contact Us</h4>
          <ul className="footer-contact">
            <li>
              <a href="mailto:aerialroot1@gmail.com">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>
           aerialrootinfotech@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+919080267314">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.34 1.78.65 2.62a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.46-1.22a2 2 0 0 1 2.11-.45c.84.31 1.72.53 2.62.65A2 2 0 0 1 22 16.92z"/></svg>
                +91 90802 67314 , +91 9629267314
              </a>
            </li>
            <li>
              <span className="footer-addr">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                D-11, Thilai Nagar, 6th Cross Rd,<br />Trichy-620018
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <p>© 2026 Aerial Root. All rights reserved.</p>
        <ul className="footer-social">
          <li><a href="https://www.facebook.com/aerialroot" target="_blank" rel="noreferrer">Facebook</a></li>
          <li><a href="https://www.instagram.com/aerialroot" target="_blank" rel="noreferrer">Instagram</a></li>
          <li><a href="https://www.linkedin.com/company/aerialroot" target="_blank" rel="noreferrer">LinkedIn</a></li>
          <li><a href="https://twitter.com/aerialroot" target="_blank" rel="noreferrer">Twitter</a></li>
        </ul>
      </div>
    </footer>
  );
}
